import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import './Accordion.scss'
import { getRandomNumber } from '../../utils/Utils';

const AMSAccordion = ({ list, onClick, selected }: any) => {

    const [expanded, setExpanded] = React.useState<string | false>(false);

    const handleChange =
        (panel: string) => (event: any, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
        };

    const LineItem = (item: any) => {
        return (
            <div className="singleLineItem">
                <div>{item.label}</div>
                <div>{item.value}</div>
            </div>
        )
    }

    return (
        <div>
            {list && list.length > 0 && list.map((item: any, pageIndex: any) => {
                return <Accordion
                    key={pageIndex + getRandomNumber()}
                    expanded={expanded === 'acc_' + pageIndex}
                    onChange={handleChange('acc_' + pageIndex)}
                    square={true}
                    className="bs-inherit"
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography variant="body2">
                            {item.title}
                        </Typography>
                        {item.subTitle && <Typography variant="subtitle2" className='color-grey3'>
                            {item.subTitle}
                        </Typography>}
                    </AccordionSummary>
                    <AccordionDetails className="d-block flex-column">
                        {item.dataItems && item.dataItems.map((mitem: any, idx: any) => {
                            return <LineItem key={idx + getRandomNumber()} {...mitem} />
                        })}
                    </AccordionDetails>
                </Accordion>
            })}
        </div>
    );
}
export default AMSAccordion